module.exports = __webpack_public_path__ + "static/img/图层21.36cdc10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层21.png
// module id = RU7K
// module chunks = 0